import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";
import BuyOnStoreButton from "web/react/components/buy-on-store-button/buy-on-store-button";
import Expandable from "web/react/components/expandable/expandable";
import PriceInfo from "web/react/components/price-info/price-info";
import Shipping from "web/react/components/shipping/shipping";
import { gettext } from "web/script/modules/django-i18n";
import { ShippingOptionPropType } from "web/types/buy-option";
import styles from "./comparison-option.module.css";

function ComparisonOption({
    className,
    formattedPrice,
    isAlternativeOption,
    isInStock,
    leadUrl,
    onSale,
    productId,
    retailerName,
    retailerSlug,
    salePrice,
    extraShipping,
    shippingOptions,
    productImageUrl,
    beforeOnBuyOnStoreClick,
}) {
    /*
        in the main price area we need html from the backend. for the price comparison we don't need this
    */
    const currentPriceHtml = onSale ? salePrice : formattedPrice;

    let selectedShipping;
    let freeShipping;
    if (shippingOptions) {
        let { cheapest, cheapest_guaranteed: guaranteed } = shippingOptions;
        if (cheapest && cheapest.is_free) {
            freeShipping = cheapest;
        }
        if (guaranteed) {
            selectedShipping = guaranteed;
        } else {
            selectedShipping = cheapest;
        }
    }

    let shouldRenderShipping = freeShipping;

    className = clsx(className, styles.wrapper);

    return (
        <div className={className}>
            <div className={styles.content}>
                <div className={styles.left}>
                    <PriceInfo
                        currentPriceHtml={currentPriceHtml}
                        formattedPrice={formattedPrice}
                        isInStock={isInStock}
                        isOnSale={onSale}
                        leadUrl={leadUrl}
                        retailerName={retailerName}
                        selectedShipping={selectedShipping}
                    />
                </div>
                <div className={styles.button}>
                    {isInStock ? (
                        <BuyOnStoreButton
                            productId={productId}
                            leadUrl={leadUrl}
                            analyticsCategoryLabel={"compare_prices"}
                            analyticsEventLabel={"comparison_option"}
                            productImageUrl={productImageUrl}
                            contextType={"comparison_option"}
                            beforeOnClick={beforeOnBuyOnStoreClick}
                            reason={
                                isAlternativeOption ? "buy-on-store-alternative-option" : undefined
                            }
                            retailerSlug={retailerSlug}
                        />
                    ) : (
                        <span className={styles.oosText}>
                            {
                                gettext("in_stock_product.compare_prices.out_of_stock_option") // "Out of stock"
                            }
                        </span>
                    )}
                </div>
            </div>
            {shouldRenderShipping && (
                <Expandable
                    className={styles.expandable}
                    renderLabel={() => (
                        <span className={styles.expandableLabel}>
                            {gettext("in_stock_product.compare_prices.all_shipping_returns.link")}
                        </span>
                    )}
                    chevronClass={styles.expandableChevron}
                >
                    <Shipping
                        freeShipping={freeShipping}
                        leadUrl={leadUrl}
                        retailerName={retailerName}
                        extraShipping={extraShipping}
                    />
                </Expandable>
            )}
        </div>
    );
}

export default ComparisonOption;

ComparisonOption.propTypes = {
    className: PropTypes.string,
    formattedPrice: PropTypes.string.isRequired,
    isAlternativeOption: PropTypes.bool.isRequired,
    isInStock: PropTypes.bool.isRequired,
    leadUrl: PropTypes.string.isRequired,
    onSale: PropTypes.bool.isRequired,
    productId: PropTypes.string.isRequired,
    retailerName: PropTypes.string.isRequired,
    retailerSlug: PropTypes.string.isRequired,
    salePrice: PropTypes.string,
    shippingOptions: PropTypes.objectOf(ShippingOptionPropType),
    extraShipping: PropTypes.object,
    productImageUrl: PropTypes.string,
    beforeOnBuyOnStoreClick: PropTypes.func,
};
